import { SVGProps } from 'react';

export type SVGRProps = {
  title?: string;
  titleId?: string;
};

const SvgInterfacetrash = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    aria-labelledby={titleId}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M10 3.412h4.47v2.353H10V3.412Zm6.941 17.176H7.53L6.824 7.294h10.94l-.823 13.294Zm3.53-14.823h-4.589V2H8.588v3.765H4v1.411h1.412L6.235 22h12l.824-14.706h1.412v-1.53Z"
      fill={props.color}
    />
  </svg>
);

export default SvgInterfacetrash;
